var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStoreBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.529,
    height: 56,
    viewBox: "0 0 167.529 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M154.188,0H13.349c-.513,0-1.021,0-1.533,0-.429,0-.854.011-1.287.018A18.5,18.5,0,0,0,7.724.268a9.331,9.331,0,0,0-2.661.878A9.013,9.013,0,0,0,2.8,2.8a8.762,8.762,0,0,0-1.65,2.27A9.242,9.242,0,0,0,.272,7.73a18.19,18.19,0,0,0-.251,2.8c-.013.429-.014.86-.021,1.289v32.36c.007.435.008.856.021,1.291a18.189,18.189,0,0,0,.251,2.8,9.223,9.223,0,0,0,.875,2.666A8.691,8.691,0,0,0,2.8,53.2a8.784,8.784,0,0,0,2.266,1.65,9.381,9.381,0,0,0,2.661.883,18.837,18.837,0,0,0,2.805.248c.433.01.858.015,1.287.015.512,0,1.019,0,1.533,0h140.84c.5,0,1.014,0,1.518,0,.427,0,.864-.005,1.291-.015a18.59,18.59,0,0,0,2.8-.248,9.526,9.526,0,0,0,2.671-.883,8.789,8.789,0,0,0,2.264-1.65,8.953,8.953,0,0,0,1.654-2.26,9.246,9.246,0,0,0,.867-2.666,18.905,18.905,0,0,0,.26-2.8c.005-.435.005-.856.005-1.291.011-.509.011-1.014.011-1.531v-29.3c0-.513,0-1.021-.011-1.529,0-.429,0-.86-.005-1.289a18.907,18.907,0,0,0-.26-2.8,9.265,9.265,0,0,0-.867-2.665,9.052,9.052,0,0,0-3.918-3.92A9.475,9.475,0,0,0,159.8.268,18.261,18.261,0,0,0,157,.02c-.427-.007-.864-.015-1.291-.018-.5,0-1.014,0-1.518,0Z",
    transform: "translate(0 0)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M11.474,54.425c-.427,0-.843-.005-1.266-.015a17.763,17.763,0,0,1-2.617-.228,8.237,8.237,0,0,1-2.319-.767,7.568,7.568,0,0,1-1.956-1.423,7.449,7.449,0,0,1-1.429-1.955,8.011,8.011,0,0,1-.76-2.32,17.379,17.379,0,0,1-.233-2.625c-.009-.3-.02-1.278-.02-1.278V11.472S.885,10.5.894,10.22A17.318,17.318,0,0,1,1.125,7.6a8.058,8.058,0,0,1,.761-2.327A7.523,7.523,0,0,1,3.307,3.315,7.792,7.792,0,0,1,5.271,1.883a8.152,8.152,0,0,1,2.315-.762,17.62,17.62,0,0,1,2.626-.23L11.474.875H155.35l1.278.018a17.339,17.339,0,0,1,2.6.228,8.314,8.314,0,0,1,2.339.767,7.831,7.831,0,0,1,3.381,3.388,8.069,8.069,0,0,1,.749,2.308,18.194,18.194,0,0,1,.243,2.642c0,.4,0,.822,0,1.246.011.525.011,1.025.011,1.529V42.3c0,.509,0,1-.011,1.505,0,.455,0,.872-.005,1.3A17.824,17.824,0,0,1,165.7,47.7a8.035,8.035,0,0,1-.756,2.338,7.673,7.673,0,0,1-1.422,1.94,7.578,7.578,0,0,1-1.959,1.431,8.207,8.207,0,0,1-2.335.77,17.559,17.559,0,0,1-2.617.228c-.41.01-.839.015-1.256.015l-1.518,0Z",
    transform: "translate(0.349 0.35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Group_",
    "data-name": "<Group>",
    transform: "translate(13.96 12.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_2",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Group_3",
    "data-name": "<Group>"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Path_",
    "data-name": "<Path>",
    d: "M30.688,22.832a6.928,6.928,0,0,1,3.3-5.813A7.092,7.092,0,0,0,28.4,14c-2.351-.247-4.63,1.407-5.828,1.407-1.221,0-3.066-1.382-5.052-1.341a7.441,7.441,0,0,0-6.262,3.819C8.55,22.57,10.569,29.46,13.163,33.249c1.3,1.855,2.814,3.928,4.8,3.855,1.942-.081,2.667-1.238,5.011-1.238,2.322,0,3,1.238,5.027,1.192,2.084-.034,3.4-1.864,4.649-3.737a15.347,15.347,0,0,0,2.126-4.33A6.7,6.7,0,0,1,30.688,22.832Z",
    transform: "translate(-9.972 -6.619)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_Path_2",
    "data-name": "<Path>",
    d: "M23.336,13.607A6.821,6.821,0,0,0,24.9,8.72a6.94,6.94,0,0,0-4.491,2.323,6.491,6.491,0,0,0-1.6,4.706A5.739,5.739,0,0,0,23.336,13.607Z",
    transform: "translate(-6.444 -8.72)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(34.238 12.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M45.452,30.764H38.825l-1.591,4.7H34.427L40.7,18.078H43.62L49.9,35.463H47.042ZM39.512,28.6h5.253L42.175,20.97H42.1Z",
    transform: "translate(-34.427 -17.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M58.571,27.819c0,3.939-2.108,6.47-5.29,6.47a4.3,4.3,0,0,1-3.988-2.218h-.06v6.278h-2.6V21.481H49.15v2.108H49.2a4.5,4.5,0,0,1,4.036-2.241C56.45,21.348,58.571,23.891,58.571,27.819Zm-2.674,0c0-2.566-1.326-4.253-3.35-4.253-1.988,0-3.325,1.723-3.325,4.253,0,2.554,1.337,4.264,3.325,4.264C54.571,32.083,55.9,30.409,55.9,27.819Z",
    transform: "translate(-29.546 -16.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M68.536,27.819c0,3.939-2.108,6.47-5.29,6.47a4.3,4.3,0,0,1-3.988-2.218H59.2v6.278H56.6V21.481h2.518v2.108h.048A4.5,4.5,0,0,1,63.2,21.348C66.415,21.348,68.536,23.891,68.536,27.819Zm-2.674,0c0-2.566-1.326-4.253-3.35-4.253-1.988,0-3.325,1.723-3.325,4.253,0,2.554,1.337,4.264,3.325,4.264,2.023,0,3.35-1.675,3.35-4.264Z",
    transform: "translate(-25.56 -16.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M72.471,30.7c.193,1.724,1.868,2.856,4.156,2.856,2.193,0,3.771-1.132,3.771-2.687,0-1.349-.952-2.157-3.2-2.711l-2.253-.543c-3.192-.771-4.674-2.264-4.674-4.687,0-3,2.614-5.06,6.326-5.06,3.674,0,6.192,2.06,6.277,5.06H80.242c-.157-1.735-1.591-2.782-3.687-2.782s-3.53,1.06-3.53,2.6c0,1.229.916,1.952,3.157,2.506l1.915.47c3.567.844,5.049,2.276,5.049,4.819,0,3.253-2.591,5.29-6.712,5.29-3.855,0-6.459-1.989-6.627-5.134Z",
    transform: "translate(-20.275 -17.871)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M84.62,19.3v3h2.41v2.06H84.62v6.988c0,1.086.483,1.591,1.542,1.591a8.13,8.13,0,0,0,.856-.06v2.048a7.145,7.145,0,0,1-1.445.12c-2.566,0-3.567-.964-3.567-3.422V24.36H80.163V22.3h1.843v-3Z",
    transform: "translate(-16.133 -17.3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M86.065,27.825c0-3.988,2.349-6.494,6.012-6.494s6.013,2.506,6.013,6.494-2.326,6.494-6.013,6.494S86.065,31.824,86.065,27.825Zm9.373,0c0-2.736-1.254-4.35-3.362-4.35s-3.361,1.627-3.361,4.35c0,2.747,1.252,4.349,3.361,4.349s3.362-1.6,3.362-4.349Z",
    transform: "translate(-13.772 -16.487)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M96.186,21.481h2.481v2.157h.06a3.023,3.023,0,0,1,3.049-2.29,4.012,4.012,0,0,1,.891.1v2.434a3.637,3.637,0,0,0-1.169-.157,2.622,2.622,0,0,0-2.711,2.916v7.518h-2.6Z",
    transform: "translate(-9.724 -16.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M112.651,30.439c-.35,2.3-2.591,3.88-5.458,3.88-3.687,0-5.976-2.471-5.976-6.434s2.3-6.554,5.867-6.554c3.507,0,5.712,2.409,5.712,6.252v.891h-8.952v.157a3.3,3.3,0,0,0,3.41,3.59,2.868,2.868,0,0,0,2.927-1.783Zm-8.8-3.783h6.337a3.048,3.048,0,0,0-3.109-3.217,3.209,3.209,0,0,0-3.228,3.217Z",
    transform: "translate(-7.712 -16.487)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Group_4",
    "data-name": "<Group>",
    transform: "translate(49.939 11.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M38.688,8.734a3.7,3.7,0,0,1,3.931,4.151c0,2.669-1.442,4.2-3.931,4.2H35.671V8.734Zm-1.72,7.172h1.575a2.626,2.626,0,0,0,2.755-3,2.633,2.633,0,0,0-2.755-2.987H36.968Z",
    transform: "translate(-35.671 -8.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M41.685,13.379a2.987,2.987,0,1,1,5.946,0,2.987,2.987,0,1,1-5.946,0Zm4.666,0c0-1.366-.614-2.166-1.691-2.166s-1.69.8-1.69,2.166.608,2.17,1.69,2.17,1.691-.8,1.691-2.17Z",
    transform: "translate(-33.271 -7.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M53.575,16.5H52.284l-1.3-4.643h-.1l-1.3,4.643H48.307l-1.738-6.3h1.262l1.129,4.81h.093l1.3-4.81h1.194l1.3,4.81h.1l1.124-4.81h1.244Z",
    transform: "translate(-31.312 -7.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M53.854,10.231h1.2v1h.093a1.887,1.887,0,0,1,1.881-1.123,2.05,2.05,0,0,1,2.182,2.345v4.081H57.963V12.767c0-1.013-.44-1.517-1.36-1.517a1.446,1.446,0,0,0-1.505,1.6v3.688H53.854Z",
    transform: "translate(-28.398 -7.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M59.094,8.437h1.244V17.2H59.094Z",
    transform: "translate(-26.302 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M61.222,13.379a2.987,2.987,0,1,1,5.947,0,2.987,2.987,0,1,1-5.947,0Zm4.666,0c0-1.366-.614-2.166-1.691-2.166s-1.69.8-1.69,2.166.608,2.17,1.69,2.17,1.691-.8,1.691-2.17Z",
    transform: "translate(-25.456 -7.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M66.4,14.751c0-1.135.845-1.789,2.345-1.882l1.708-.1v-.544c0-.666-.44-1.042-1.291-1.042-.695,0-1.176.255-1.314.7h-1.2c.127-1.083,1.146-1.777,2.576-1.777,1.58,0,2.472.787,2.472,2.118v4.307h-1.2v-.886h-.1a2.121,2.121,0,0,1-1.894.99,1.9,1.9,0,0,1-2.1-1.887Zm4.052-.539v-.527l-1.539.1c-.868.058-1.262.353-1.262.909s.492.9,1.169.9a1.486,1.486,0,0,0,1.632-1.378Z",
    transform: "translate(-23.379 -7.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M71.348,14.047c0-1.992,1.024-3.254,2.617-3.254A2.078,2.078,0,0,1,75.9,11.9h.093V8.437h1.244V17.2H76.043v-1h-.1a2.188,2.188,0,0,1-1.98,1.1C72.361,17.306,71.348,16.044,71.348,14.047Zm1.285,0c0,1.337.63,2.142,1.684,2.142s1.7-.816,1.7-2.136-.655-2.142-1.7-2.142-1.684.81-1.684,2.136Z",
    transform: "translate(-21.4 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M79.234,13.379a2.987,2.987,0,1,1,5.946,0,2.987,2.987,0,1,1-5.946,0Zm4.666,0c0-1.366-.614-2.166-1.691-2.166s-1.69.8-1.69,2.166.608,2.17,1.69,2.17S83.9,14.751,83.9,13.379Z",
    transform: "translate(-18.252 -7.769)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M84.669,10.231h1.2v1h.093a1.887,1.887,0,0,1,1.881-1.123,2.05,2.05,0,0,1,2.182,2.345v4.081H88.779V12.767c0-1.013-.44-1.517-1.36-1.517a1.446,1.446,0,0,0-1.505,1.6v3.688H84.669Z",
    transform: "translate(-16.072 -7.77)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M94.157,9.074v1.6h1.366V11.72H94.157v3.242c0,.66.272.95.891.95a4.153,4.153,0,0,0,.474-.029v1.036a4.082,4.082,0,0,1-.677.064c-1.384,0-1.935-.487-1.935-1.7V11.72h-1V10.672h1v-1.6Z",
    transform: "translate(-13.175 -8.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M95.7,8.437h1.233v3.474h.1a1.94,1.94,0,0,1,1.922-1.129,2.077,2.077,0,0,1,2.171,2.35V17.2H99.884V13.439c0-1.007-.469-1.517-1.348-1.517a1.473,1.473,0,0,0-1.587,1.6V17.2H95.7Z",
    transform: "translate(-11.658 -8.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M106.381,14.832a2.559,2.559,0,0,1-2.732,1.824,2.863,2.863,0,0,1-2.912-3.254,2.908,2.908,0,0,1,2.907-3.294c1.754,0,2.812,1.2,2.812,3.178v.434h-4.452v.07a1.666,1.666,0,0,0,1.679,1.806,1.511,1.511,0,0,0,1.5-.764ZM102.005,12.8h3.184a1.521,1.521,0,0,0-1.552-1.633,1.612,1.612,0,0,0-1.632,1.633Z",
    transform: "translate(-9.655 -7.769)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreBadge);
export default __webpack_public_path__ + "static/media/App Store Badge.3eaa96890f03b18d97305c2f168b56f7.svg";
export { ForwardRef as ReactComponent };